import React from 'react';

const AdminDashboard = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex flex-col items-center justify-center px-4 transition-colors duration-300">
      <div className="text-center max-w-3xl">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-6 text-gray-900 dark:text-white tracking-tight">
          AdminDashboard
        </h1>

        <div className="space-y-6 mb-12">
          <p className="text-xl md:text-2xl text-gray-600 dark:text-gray-300 font-light">
            Coming Soon
          </p>

          <p className="text-lg text-gray-500 dark:text-gray-400 max-w-2xl mx-auto">
            We're working hard to bring you something awesome. Stay tuned!
          </p>
        </div>

        {/* Optional subtle animated dots / loader */}
        <div className="flex justify-center items-center gap-3 mb-16">
          <div className="w-3 h-3 rounded-full bg-gray-400 dark:bg-gray-600 animate-bounce" style={{ animationDelay: '0ms' }}></div>
          <div className="w-3 h-3 rounded-full bg-gray-400 dark:bg-gray-600 animate-bounce" style={{ animationDelay: '150ms' }}></div>
          <div className="w-3 h-3 rounded-full bg-gray-400 dark:bg-gray-600 animate-bounce" style={{ animationDelay: '300ms' }}></div>
        </div>
    </div>
    </div>
  );
};

export default AdminDashboard;